<template>
  <div class="c-body">
    <div class="c-body__banner"></div>
    <!-- <div class="c-body__banner-copy" v-html="bannerContent.FieldValues.Text"></div> -->

    <div class="c-body__mobile-cards">
      <slick ref="slick" :options="slickOptions">
        <div
          class="c-body__mobile-cards-wrapper"
          v-for="(card, index) in promoContent"
          v-bind:key="index"
        >
          <card
            v-bind:title="card.FieldValues.Title"
            v-bind:name="card.FieldValues.Parameters.name"
            v-bind:number="card.FieldValues.Parameters.number"
            v-bind:date="card.FieldValues.Parameters.date"
            v-bind:image="card.FieldValues.Image"
            @cardClicked="openPopup"
            :data-popup="card.FieldValues.Parameters.number"
            v-bind:class="isActive(card.FieldValues.Parameters.number)"
          ></card>
        </div>
      </slick>
    </div>

    <div class="c-body__cards">
      <card
        v-for="(card, index) in promoContent"
        v-bind:key="index"
        v-bind:title="card.FieldValues.Title"
        v-bind:name="card.FieldValues.Parameters.name"
        v-bind:number="card.FieldValues.Parameters.number"
        v-bind:date="card.FieldValues.Parameters.date"
        v-bind:image="card.FieldValues.Image"
        @cardClicked="openPopup"
        :data-popup="card.FieldValues.Parameters.number"
        v-bind:class="isActive(card.FieldValues.Parameters.number)"
      ></card>
    </div>

    <transition name="pop-in">
      <popup
        v-show="isPopupOpen"
        v-bind:image="promoContent[currentDay].FieldValues.Image"
        v-bind:title="promoContent[currentDay].FieldValues.Title"
        v-bind:name="promoContent[currentDay].FieldValues.Parameters.name"
        v-bind:number="promoContent[currentDay].FieldValues.Parameters.number"
        v-bind:date="promoContent[currentDay].FieldValues.Parameters.date"
        v-bind:header="promoContent[currentDay].FieldValues.Parameters.header"
        v-bind:content="promoContent[currentDay].FieldValues.Text"
        v-bind:termsButton="promoContent[currentDay].ChildItems[0].FieldValues.Title"
        v-bind:terms="promoContent[currentDay].ChildItems[0].FieldValues.Text"
        @closePopup="closePopup"
      ></popup>
    </transition>
  </div>
</template>
<script>
/* eslint-env browser */

import Vue from "vue"; // eslint-disable-line no-unused-vars
import { mapGetters } from "vuex";
import Slick from "vue-slick";
import cardComponent from "./card.vue";
import popupComponent from "./popup.vue";
import "../../node_modules/slick-carousel/slick/slick.css";

export default {
  components: {
    Slick,
    card: cardComponent,
    popup: popupComponent
  },
  computed: {
    ...mapGetters({
      host: "getHost",
      isMobile: "getIsMobile",
      labels: "getLabels",
      language: "getLanguage",
      loggedIn: "getLoggedIn",
      raffleEntries: "getRaffleEntries",
      isMaintenanceTime: "isMaintenanceTime",
      isClosed: "isClosed",
      promoContent: "getPromoContent",
      bannerContent: "getBannerContent"
    })
  },
  methods: {
    generateDate(cardNumber) {
      let offset = cardNumber - 1;
      let today = new Date();

      let computeCardDay = function() {
        const currentDayOfTheWeek = today.getDay();
        let offset = cardNumber - currentDayOfTheWeek;
        return today.getDate() + offset;
      };

      let monthFormat = function(month) {
        if (month < 10) return "0" + month;
        return month;
      };

      // Default
      // dd-mm-yy
      let delimeter = "-";

      if (["en", "de", "el"].includes(this.language)) {
        // dd.mm.yy
        delimeter = ".";
      }

      if (["pt-br"].includes(this.language)) {
        // dd/mm/yy
        delimeter = "/";
      }

      return (
        computeCardDay() +
        delimeter +
        monthFormat(today.getMonth() + 1) +
        delimeter +
        today.getFullYear()
      );
    },
    // isActive(date) {
    //   const cardDay = date.split(".")[0];
    //   const currentDay = new Date().getDate();

    //   return {
    //     "active-card": Number(cardDay) === currentDay ? true : false
    //   };
    // },
    isActive(number) {
      let dayOfTheWeek = new Date().getDay();
      let activeDay = number;
      // Set sunday as nr 7
      if (dayOfTheWeek === 0) dayOfTheWeek = 7;


      return {
        "active-card": Number(number) === dayOfTheWeek ? true : false
      };
    },

    // openPopup(card) {
    //   const cardDay = card.date.split(".")[0];
    //   const currentDayNr = new Date().getDate();

    //   // Check if its qa param has beend passed via url
    //   const uri = window.location.search.substring(1);
    //   const qaParam = new URLSearchParams(uri).get("qapromo");

    //   if (Number(cardDay) === currentDayNr || qaParam !== null) {
    //     this.currentDay = card.cardNumber - 1;
    //     this.isPopupOpen = true;
    //   }
    // },

    openPopup(val) {
      // Get day of the week nr
      let dayOfTheWeek = new Date().getDay();
      
      let activeDay = this.promoContent.filter(promoContent => promoContent.FieldValues.Parameters.number === val);
      activeDay = activeDay[0].ItemName;
      activeDay = activeDay.replace(/\D/g,'')
      console.log(this.promoContent);
      console.log(activeDay);
      

      // Set sunday as nr 7
      if (dayOfTheWeek === 0) dayOfTheWeek = 7;

      // Check if its qa param has beend passed via url
      let uri = window.location.search.substring(1);
      let params = new URLSearchParams(uri);
      const qa = params.get("qapromo");

      // If clicked day is today OR qa param is present - open popup
      if (Number(val) === dayOfTheWeek || qa === "true") {
        
        this.currentDay = activeDay - 1;
        this.isPopupOpen = true;
        
      }
    },

    closePopup() {
      this.isPopupOpen = false;
    },
    next() {
      this.$refs.slick.next();
    },
    prev() {
      this.$refs.slick.prev();
    },
    reInit() {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$refs.slick.reSlick();
    }
  },
  data: function() {
    return {
      isPopupOpen: false,
      currentDay: 0,
      slickOptions: {
        centerMode: true,
        centerPadding: 200,
        slidesToShow: 3,
        infinite: true,
        accessibility: true,
        adaptiveHeight: false,
        arrows: true,
        dots: false,
        draggable: true,
        edgeFriction: 0.3,
        swipe: true,
        responsive: [
          {
            breakpoint: 520,
            settings: {
              slidesToShow: 1,
              infinite: true
            }
          },
          {
            breakpoint: 300,
            settings: "unslick" // destroys slick
          }
        ]
      },
      cards: [
        {
          image: "",
          title: "Monday",
          name: "Free Click Card",
          number: 1,
          popup: {
            date: "06.05.19",
            header: "FREE CLICK CARD – GUARANTEED WIN!",
            content:
              "<p>Start the week off with a guaranteed prize – opt in and crack open an exotic Click Card here today to discover what you’ve won.</p><p>Register now by clicking the OPT IN button above.</p>",
            cta: "OPT IN",
            ctaUrl:
              "https://my.sportingbet.com/en/registration?_layout=layouts%2fportaloverlaylayout&.box=1"
          }
        },
        {
          image: "",
          title: "Tuesday",
          name: "25% Reload",
          number: 2,
          popup: {
            date: "07.05.19",
            header: "FREE CLICK CARD – GUARANTEED WIN!",
            content:
              "<p>Enjoy a 25% frequent-flier reload bonus today! Simply deposit £20 or more using bonus code XXXXXXX!</p>",
            cta: "DEPOSIT NOW",
            ctaUrl:
              "https://my.sportingbet.com/en/registration?_layout=layouts%2fportaloverlaylayout&.box=1"
          }
        },
        {
          image: "",
          title: "Wednesday",
          name: "10% bonus back",
          number: 3,
          popup: {
            date: "08.05.19",
            header: "FREE CLICK CARD – GUARANTEED WIN!",
            content:
              "<p>Start the week off with a guaranteed prize – opt in and crack open an exotic Click Card here today to discover what you’ve won.</p><p>Register now by clicking the OPT IN button above.</p>",
            cta: "OPT IN",
            ctaUrl:
              "https://my.sportingbet.com/en/registration?_layout=layouts%2fportaloverlaylayout&.box=1"
          }
        },
        {
          image: "",
          title: "Thursday",
          name: "20 Free Spins",
          number: 4,
          popup: {
            date: "09.05.19",
            header: "FREE CLICK CARD – GUARANTEED WIN!",
            content:
              "<p>Start the week off with a guaranteed prize – opt in and crack open an exotic Click Card here today to discover what you’ve won.</p><p>Register now by clicking the OPT IN button above.</p>",
            cta: "OPT IN",
            ctaUrl: "https://my.sportingbet.com/en/account/freespins"
          }
        },
        {
          image: "",
          title: "Friday",
          name: "Leaderboard",
          number: 5,
          popup: {
            date: "10.05.19",
            header: "FREE CLICK CARD – GUARANTEED WIN!",
            content:
              "<p>Start the week off with a guaranteed prize – opt in and crack open an exotic Click Card here today to discover what you’ve won.</p><p>Register now by clicking the OPT IN button above.</p>",
            cta: "OPT IN",
            ctaUrl:
              "https://my.sportingbet.com/en/registration?_layout=layouts%2fportaloverlaylayout&.box=1"
          }
        },
        {
          image: "",
          title: "Saturday",
          name: "Leaderboard",
          number: 6,
          popup: {
            date: "11.05.19",
            header: "FREE CLICK CARD – GUARANTEED WIN!",
            content:
              "<p>Start the week off with a guaranteed prize – opt in and crack open an exotic Click Card here today to discover what you’ve won.</p><p>Register now by clicking the OPT IN button above.</p>",
            cta: "OPT IN",
            ctaUrl:
              "https://my.sportingbet.com/en/registration?_layout=layouts%2fportaloverlaylayout&.box=1"
          }
        },
        {
          image: "",
          title: "Sunday",
          name: "Leaderboard",
          number: 7,
          popup: {
            date: "12.05.19",
            header: "FREE CLICK CARD – GUARANTEED WIN!",
            content:
              "<p>Start the week off with a guaranteed prize – opt in and crack open an exotic Click Card here today to discover what you’ve won.</p><p>Register now by clicking the OPT IN button above.</p>",
            cta: "OPT IN",
            ctaUrl:
              "https://my.sportingbet.com/en/registration?_layout=layouts%2fportaloverlaylayout&.box=1"
          }
        }
      ]
    };
  }
};
</script>






// WEBPACK FOOTER //
// src/components/body-component.vue